import React from 'react';

type LinkItem = {
    text: string;
    onClick?: () => void;
    isLink?: boolean;
};

type CheckboxProps = {
    register?: any;
    disabled?: boolean;
    id?: string;
    name?: string;
    labelText?: string;
    customLabelClassName?: string;
    links?: LinkItem[];
    errorMessage?: React.ReactNode;
    checked?: boolean;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    variant?: 'checkbox' | 'toggle'; // Added toggle variant
    title?: string; // Added for toggle title
};

const Checkbox: React.FC<CheckboxProps> = ({
    register,
    disabled = false,
    id = 'Checkbox',
    name = 'agree_tnc',
    labelText = '',
    customLabelClassName,
    links = [],
    errorMessage,
    checked,
    onChange,
    variant = 'checkbox',
    title = '',
}) => {
    const [isFocused, setIsFocused] = React.useState(false);
    const uniqueId = React.useId();
    const inputId = id === 'Checkbox' ? `${uniqueId}-checkbox` : id;

    if (variant === 'toggle') {
        return (
            <div className="toggle-wrapper">
                {title && (
                    <div className="toggle-header">
                        <h3 className="toggle-title">{title}</h3>

                        <label className="toggle-switch">
                            <input
                                type="checkbox"
                                id={inputId}
                                name={name}
                                disabled={disabled}
                                checked={checked}
                                onChange={onChange}
                                {...register}
                                onFocus={() => setIsFocused(true)}
                                onBlur={() => setIsFocused(false)}
                            />
                            <span 
                                className="toggle-slider"
                                style={{
                                    outline: isFocused ? '2px solid #5252F6' : 'none',
                                    outlineOffset: '2px',
                                }}
                            ></span>
                        </label>
                    </div>
                )}

                {labelText && (
                    <p className={customLabelClassName ? customLabelClassName : `toggle-description`}>{labelText}</p>
                )}

                {errorMessage}
            </div>
        );
    }


    return (
        <div className="com-check auth-check">
            <div className="checkbox-row">
                <input
                    type="checkbox"
                    className="form-check-input custom-checkbox position-absolute"
                    style={{ display: 'block', opacity: 0, pointerEvents: 'none', width: '20px', height: '20px', zIndex: -1 }}
                    id={inputId}
                    name={name}
                    disabled={disabled}
                    checked={checked}
                    onChange={onChange}
                    {...(register && name ? register(name) : {})}
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                />

                <label className={`form-check-label ${customLabelClassName || ''}`} htmlFor={inputId}>
                    <span 
                        className="check-icon" 
                        style={{
                            outline: isFocused ? '2px solid #5252F6' : 'none',
                            outlineOffset: '2px',
                            borderRadius: '4px'
                        }}
                    />
                    <span className={`checkbox-text`}>
                        {labelText}{' '}
                        {links.map((item, index) => (
                            <span key={index}>
                                {item.isLink ? (
                                    <a
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            item.onClick?.();
                                        }}
                                        className="text-decoration-underline cursor-pointer"
                                        data-bs-toggle="modal"
                                        data-bs-target="#exampleModal"
                                    >
                                        {item.text}
                                    </a>
                                ) : (
                                    <span onClick={(e) => e.stopPropagation()}>{item.text}</span>
                                )}
                                {index < links.length - 1 ? ' ' : ''}
                            </span>
                        ))}
                    </span>
                </label>
            </div>

            {errorMessage}
        </div>
    );
};

export default Checkbox;